export const servicesData = [
    {
        image: 'Images/computer-rent.jpg',
        title: 'Computer Rental',
        description: 'We offer Desktop Computer rentals to match your hardware requirements with all kinds of customization options. You can take Computer on Rent for Projects, Seminars, Office Setup, Call Centres and more.'
    },
    {
        image: 'Images/laptop-rent.jpg',
        title: 'Laptop Rental',
        description: 'We provide Laptop on Rent with a varied configuration starting from Dual Core to the fastest i7 processors in the market. RAM can be customized with option of both normal and SSD Hard Disk.'
    },
    {
        image: 'Images/refurbished.png',
        title: 'Refurbished Laptops',
        description: 'We sell premium used laptops, Old Laptops & certified refurbished laptop India with insane cheap prices without compromising the quality.'
    },
    {
        image: 'Images/amc.jpg',
        title: 'AMC',
        description: 'We provide AMC services for both Computers and Laptops, we provide chip level services for the IT Products.'
    },
    {
        image: 'Images/data-recovery.jpg',
        title: 'Data Recovery',
        description: 'Data recovery is the process of restoring lost files from Laptops, Desktops, Pen drives, Memory Cards etc. We offer quality data recovery services on affordable prices.'
    },
    {
        image: 'Images/onsite-support.png',
        title: 'Onsite Support',
        description: 'In the world of emergency if you want us anytime, we are just a call away. We provide team who can provide support on your place for what you need.'
    }
];